import { getUser } from '~src/user';
import { getAuth0Client } from '~auth';
import isMobile from 'is-mobile';

const REDIRECT_CALLBACK = (redirectUrl = process.env.ROUTE_START) => {
  window.location.href = window.location.origin + redirectUrl;
};

export const handleAuthCallback = async () => {
  const auth0 = await getAuth0Client();

  const isAuthenticated = await auth0.isAuthenticated();

  const query = window.location.search;

  if (query.includes('code=') && query.includes('state=')) {
    try {
      await auth0.handleRedirectCallback();
      await auth0.getUser();

      const { editorCanvas } = await getUser({}, true);

      let redirectPath;
      let query;

      const rawAuthRedirect = localStorage.getItem('authRedirect');

      if (rawAuthRedirect && typeof rawAuthRedirect === 'string') {
        try {
          const authRedirect = JSON.parse(rawAuthRedirect);
          redirectPath = authRedirect.url;
          query = authRedirect.queryString;
          localStorage.removeItem('authRedirect');
        } catch (err) {
          console.error(err);
        }
      }

      // From mobile, we display a banner asking to contact us
      if (isMobile()) {
        redirectPath = process.env.ROUTE_START;
      } else if (query && editorCanvas && editorCanvas.objectId) {
        redirectPath = `${process.env.ROUTE_CANVAS}/${editorCanvas.objectId}?${query}`;
      }

      if (redirectPath) {
        const url = query ? `/${redirectPath}?${query}` : `/${redirectPath}`;
        REDIRECT_CALLBACK(url);
      } else {
        REDIRECT_CALLBACK(process.env.ROUTE_START);
      }

      return;
    } catch (error) {
      console.error(error);
      // Invalid State
      REDIRECT_CALLBACK(process.env.ROUTE_LOGOUT);
      return;
    }
  } else if (isAuthenticated) {
    REDIRECT_CALLBACK();
    return;
  } else if (!isAuthenticated) {
    window.location.href = process.env.ROUTE_LOGIN;
    return;
  }
};
